// extracted by mini-css-extract-plugin
export default {"box":"Box_box__-e+G9","noPadding":"Box_noPadding__RMSl2","booker":"Box_booker__88cfv","info":"Box_info__cY9Nq","small":"Box_small__av6uS"};